import { render, staticRenderFns } from "./ExcSwitch.vue?vue&type=template&id=f2ad3c5a&scoped=true&"
import script from "./ExcSwitch.vue?vue&type=script&lang=ts&"
export * from "./ExcSwitch.vue?vue&type=script&lang=ts&"
import style0 from "./ExcSwitch.vue?vue&type=style&index=0&id=f2ad3c5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2ad3c5a",
  null
  
)

export default component.exports